import detectSticky from "./components/detect-sticky";
import openCloseMenu from "./components/open-close-menu";
import barba from "@barba/core";
import homeJs from "../js/home";
import solutionsJs from "./solutions";
import sustainabilityJs from "./sustainability";
import networkJs from "./network";
import agentsNetworkJs from "./agentsNetwork";
import fleetJs from "./fleet";
import aboutJs from "./about";
import careersJs from "./careers";
import contactJs from "./contact";
import newsJs from "./news";
import announcementsJs from "./announcements";
import newsSlider from "./components/newsSlider";
import { removeTriggers, triggerCounters } from "./components/animatedCounters";

detectSticky();

openCloseMenu();

// addDelayInSlides();

animateObserverFunction();

const promoCards = document.querySelectorAll(".promoCardsBlock .animateEl");

promoCards &&
	promoCards.forEach(
		(elem, index) => (elem.style.transitionDelay = `${index * 0.25}s`)
	);

document
	.querySelectorAll(".menuStatus li a")
	.forEach((elem, index) => (elem.style.transitionDelay = `${index * 0.15}s`));

const reversedTransitions = false;
const loaderBar = document.querySelector(".loader-indicator");

barba.init({
	transitions: [
		{
			sync: true,
			before({ current, next }) {
				let transitionDelay = current.namespace == "home" ? 2200 : 1500;
				window.scrollTo({
					top: 0,
					left: 0,
					behavior: "auto",
				});
				setTimeout(() => {
					current.namespace !== "home" &&
						document.body.classList.remove(current.namespace);
					document
						.querySelectorAll("main .activate")
						.forEach((elem) => elem.classList.remove("activate"));
				}, 150);
				current.namespace == "home" &&
					setTimeout(() => {
						document.body.classList.remove("home");
						document.body.classList.add(next.namespace);
					}, transitionDelay - 200);
				loaderBar.classList.add("start");

				return new Promise((resolve) => {
					setTimeout(() => {
						resolve();
					}, transitionDelay);
				});
			},
			leave() {
				loaderBar.classList.add("end");
				removeTriggers();
			},
			afterLeave() {
				window.scrollTo({
					top: 0,
					left: 0,
					behavior: "auto",
				});
			},
			enter() {
				// create your amazing enter animation here
				const transition = document.querySelector("main .animateEl");
				animateObserverFunction();
				document.querySelectorAll("video").forEach((elem) => elem.play());
				transition.addEventListener("transitionend", () => {
					reversedTransitions = false;
				});
			},
			after({ current, next }) {
				setTimeout(() => {
					loaderBar.classList.remove("start");
					loaderBar.classList.remove("end");
				}, 1000);

				document.body.classList.add(next.namespace);
			},

			// to: {
			// 	custom: () =>
			// 		setInterval(() => {
			// 			return reversedTransitions;
			// 		}, 100),
			// },
		},
	],
	views: [
		{
			namespace: "home",
			afterEnter() {
				setTimeout(() => homeJs(), 500);
				newsSlider();
			},
		},
		{
			namespace: "solutions",
			beforeLeave() {
				newsItemsSwiper.destroy;
			},
			afterEnter() {
				solutionsJs();
				newsSlider();
			},
		},
		{
			namespace: "sustainability",
			afterEnter() {
				setTimeout(() => sustainabilityJs(), 500);
				newsSlider();
			},
		},
		{
			namespace: "network",
			afterEnter() {
				setTimeout(() => networkJs(), 500);
				newsSlider();
			},
		},
		{
			namespace: "agencynetwork",
			afterEnter() {
				setTimeout(() => {
					agentsNetworkJs();
					newsSlider();
				}, 500);
			},
		},
		{
			namespace: "fleet",
			afterEnter() {
				setTimeout(() => {
					fleetJs();
					newsSlider();
				}, 500);
			},
		},
		{
			namespace: "about",
			afterEnter() {
				setTimeout(() => {
					aboutJs();
					newsSlider();
				}, 500);
			},
		},
		{
			namespace: "workwithus",
			afterEnter() {
				setTimeout(() => {
					careersJs();
					newsSlider();
				}, 500);
			},
		},
		{
			namespace: "contact",
			afterEnter() {
				setTimeout(() => contactJs(), 500);
			},
		},
		{
			namespace: "newslist",
			afterEnter() {
				setTimeout(() => {
					newsJs();
					announcementsJs();
					// newsSlider();
				}, 500);
			},
		},
		{
			namespace: "newsitem",
			afterEnter() {
				setTimeout(() => {
					// newsJs();
					// announcementsJs();
					newsSlider();
				}, 500);
			},
		},
	],
});

document.addEventListener("click", function (e) {
	if (e.target.matches('a[data-barba="link"]')) {
		// Prevent the browser from navigating to the new page
		e.preventDefault();
	}
});
export function animateObserverFunction() {
	const elementsToObserve = document.querySelectorAll(".animateEl");
	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting && entry.intersectionRatio >= 0.1) {
					entry.target.classList.add("activate");
				}
			});
		},
		{
			threshold: 0.2, // Set the threshold to 20%
		}
	);
	// Observe each element
	elementsToObserve.forEach((el) => {
		observer.observe(el);
	});
}
